import React from 'react';
export function SmartSegmentationHeader() {
  return <header className="fixed top-0 z-50 w-full bg-white shadow-sm py-3" data-id="element-682">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-683">
                <div className="flex justify-between items-center" data-id="element-684">
                    <div className="flex items-center" data-id="element-685">
                        <a href="/" className="flex-shrink-0" data-id="element-686">
                            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/debbab01-79d9-49e0-a766-2a2a9aeb34ad/Nf_final.png" alt="Newsfiliate Logo" className="h-8" data-id="element-687" />
                        </a>
                    </div>

                    {/* Empty space for navigation - intentionally left blank */}
                    <div className="flex-1" data-id="element-688"></div>

                    <div className="flex items-center" data-id="element-689">
                        <a href="#join-beta" className="px-5 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-all hover:shadow-md" data-id="element-690">
                            Join Beta
                        </a>
                    </div>
                </div>
            </div>
        </header>;
}